export enum GuidesGridType {
  ThreeWide = 'ThreeWide',
  AcceptReject = 'AcceptReject'
}
